import React from 'react';
import { storage } from '../helpers';
import {
  Col,
  Row
} from 'react-bootstrap';
import CollapsiblePanelContainer from '../Containers/CollapsiblePanelContainer';
import NotificationsContainer from '../Containers/NotificationsContainer';
import ProfileOptionsContainer from '../Containers/ProfileOptionsContainer';
import CustomNavContainer from '../Containers/CustomNavContainer';


const ProfileComponent = () => (
  <div>
    <Row>
      <Col md={2} mdOffset={7}>
        <div className="flex">
          <div className="flex-align-end">
            <h2 style={{ display: 'inline', margin: '20px' }} >
              {localStorage.getItem(storage.USER_KEY)}
            </h2>
          </div>
          <img
            name={'avatar'}
            src={localStorage.getItem(storage.AVATAR_URL_LARGE)}
            style={{
              height: 100,
              width: 100
            }}
          />
        </div>
      </Col>
    </Row>
    <hr />
    <Row>
      <Col md={8} mdOffset={2}>
        <CollapsiblePanelContainer
          title={
            <div className="flex">
              <div className="flex-grow">
                Options
              </div>
            </div>
          }
        >
          <ProfileOptionsContainer />
        </CollapsiblePanelContainer>
      </Col>
    </Row>
    <Row>
      <Col md={8} mdOffset={2}>
        <CollapsiblePanelContainer
          title={
            <div className="flex">
              <div className="flex-grow">
                Notifications
              </div>
            </div>
          }
        >
          <NotificationsContainer />
        </CollapsiblePanelContainer>
      </Col>
    </Row>
    <Row>
      <Col md={8} mdOffset={2}>
        <CollapsiblePanelContainer
          title={
            <div className="flex">
              <div className="flex-grow">
                Customize Tabs
              </div>
            </div>
          }
        >
          <CustomNavContainer />
        </CollapsiblePanelContainer>
      </Col>
    </Row>
  </div>
);

export default ProfileComponent;


// WEBPACK FOOTER //
// src/Components/ProfileComponent.jsx